import { i18n } from 'i18next';

/**
 * Finds the first existing translation key from an array of keys and returns it,
 * or falls back to a default value if none of the keys exist.
 *
 * @param {i18n} i18n - The i18next translation function
 * @param {string[]} keys - Array of translation keys to check
 * @param {string} defaulValue - Default value to return if no translation keys exist
 * @returns {string} The first found translation key or the default value
 *
 * @example
 * const keys = ['key1', 'key2', 'key3'];
 * const result = multipleKeyTranslation(i18n, keys, 'default text');
 */
export function multipleKeyTranslation(
    i18n: i18n,
    keys: string[],
    defaulValue: string
) {
    const foundKey = keys.find((key) => i18n.exists(key));
    return foundKey || defaulValue;
}
